import { HttpBase, type HttpResult } from '@library/Security';

export const useCarePlanApi = () => new class extends HttpBase
{

    /**
     * Get the Carbucks REWARDS document urls for the vehicle
     * @param vehicleId 
     * @returns 
     */
    async getCarbucksRewardsDocumentUrls( vehicleId: string )
    {
        const result = await this.get( 'api/care-plan/carbucks-rewards/document-urls', { vehicleId } );
        if( result.success )
        {
            return result.data;
        }
        return null;
    }
    
    /**
     * Get the Carbucks PROTECT document urls for the vehicle
     * @param vehicleId 
     * @returns 
     */
    async getCarbucksProtectDocumentUrls( vehicleId: string )
    {
        const result = await this.get( 'api/care-plan/carbucks-protect/document-urls', { vehicleId } );
        if( result.success )
        {
            return result.data;
        }
        return null;
    }

    /**
     * Acknowledges a Carbucks PROTECT cover
     * @returns
     */
    async acknowledgeCarbucksProtect( vehicleId: string ) : HttpResult<{ dateActiveFrom: string }>
    {
        const request = { vehicleId };
        const result = await this.put( 'api/care-plan/carbucks-protect/acknowledge', request );
        return result;
    }

}


